export default {
  id: 'travel-expense',
  title: 'Travel Expense Report',
  category: 'Employee',
  summary: 'Build a pre-travel estimate, submit for approval, then enter actuals and receipts after the trip.',
  overview: 'Travel expenses follow a two-phase workflow: estimates before travel, and actuals after. Reviewers use the estimate to approve the trip plan, then reconcile actual spend with receipts. Location entry can look up DoD per diem rates (lodging and meals) when your company has imported them in Settings.',
  howItWorks: [
    'Create or edit a draft with trip details, locations, and estimated line items.',
    'When adding a location, search for a destination; Timeclerk can suggest county/rate candidates from imported per diem data (with zip fallback when needed).',
    'Submit the estimate for approval. Editing is limited while it awaits review.',
    'After approval (and after travel), open Actuals to replace estimates with real amounts and attach receipts.',
    'Submitting actuals returns the report to reviewers for reimbursement processing.',
    'Rejection returns the report to you with a reason so you can correct and resubmit.'
  ],
  actions: [
    {
      name: 'Add location',
      description: 'Captures where travel occurred. Destination search uses company per diem rates when available so lodging/meals estimates can align with DoD tables.'
    },
    {
      name: 'Add expense type / line item',
      description: 'Adds lodging, meals, mileage, or other travel cost lines with estimated amounts.'
    },
    {
      name: 'Save draft',
      description: 'Stores progress without submitting. The report remains editable.'
    },
    {
      name: 'Submit for approval',
      description: 'Sends the estimate to expense reviewers. Status moves to awaiting approval.'
    },
    {
      name: 'Enter actuals',
      description: 'Opens the actuals workflow to record real costs and upload receipts after travel.'
    }
  ],
  tips: [
    'Keep estimates realistic — large variances between estimate and actuals may slow reimbursement.',
    'If destination rates are missing, ask an administrator to import current DoD per diem files under Settings → Per Diem Rates.',
    'Upload clear receipt images when entering actuals.'
  ],
  related: ['expenses', 'expense-wizard', 'expense-review', 'settings']
};



// WEBPACK FOOTER //
// ./client/help/content/travel-expense.js